import _ from 'lodash';

export default {
    debug: true,

    state: {
        treatments: []
    },

    addTreatment() {
        let maxId = 0;

        if(this.debug) {
            console.log('Adding new treatment');
        }

        // get max id and increment it
        if( this.state.treatments.length !== 0) {

            maxId = _.maxBy(this.state.treatments, item => { return item.id; }).id;
        }

        this.state.treatments.push({
            id: maxId + 1,
            title: '',
            appliance_id: '',
            method_id: '',
            description: '',
            water: '',
            time: ''
        });
    },

    addLoadedTreatment(item) {
        this.state.treatments.push(item);
    },

    getTreatment(index) {
        return _.find(this.state.treatments, {id: index});
    }
};